<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>法律服务</el-breadcrumb-item>
        <el-breadcrumb-item>浏览统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="栏目名称：" prop="name">
          <el-input v-model="listParams.name" placeholder="请输入栏目名称" clearable />
        </el-form-item>
        <el-form-item label="栏目类型：" prop="type">
          <el-select v-model="listParams.type" placeholder="请选择栏目类型" clearable>
            <el-option v-for="item in ColumnTypeList" :label="item.label" :value="item.value" :key="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh"> 查询 </el-button>

          <el-button size="small" @click="resetForm('listForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="dataLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="name" align="left" label="栏目名称" />

        <el-table-column prop="content" align="left" label="栏目内容">
          <template slot-scope="scope">
            <span v-if="scope.row.content">
              {{ scope.row.content.length > 100 ? scope.row.content.substring(0, 100) + "..." : scope.row.content }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="type" align="center" label="栏目类型">
          <template slot-scope="scope">
            <span>{{ ColumnTypeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="seeNumber" align="center" label="浏览量" />
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import Vue from "vue";
import { ColumnTypeList, ColumnTypeMap } from "./const";

export default {
  data() {
    return {
      dataLoading: false,
      listParams: { name: "", type: "", pageIndex: 1, pageSize: 15 },
      ColumnTypeMap,
      ColumnTypeList,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },

  mounted() {
    this.loadTableData();
  },

  methods: {
    handleRefresh() {
      this.listParams.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    async loadTableData() {
      this.dataLoading = true;
      try {
        const response = await Vue.ajaxGet(this, global.apiUrl + "/law/help/all/list", this.listParams, "dataLoading");
        this.tableData = response.content || [];
        this.pager.total = response.totalElements || 0;
        this.pager.pageSize = response.size || 0;
        this.pager.pageIndex = this.listParams.pageIndex || 1;
        this.dataLoading = false;
      } catch (error) {
        this.dataLoading = false;
      }
    },

    /**
     * 切换页码
     * @param pageIndex
     */
    handleCurrentChange(pageIndex) {
      this.listParams.pageIndex = pageIndex;
      this.loadTableData();
    },

    /**
     * 切换每页显示条数
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.listParams.pageSize = pageSize;
      this.loadTableData();
    },

    /**
     * 重置表单
     * @param formName
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .pageWrapper {
    display: flex;
    justify-content: space-between;
    .leftWrapper {
      width: 400px;
      .nodeWrapper {
        width: calc(100% - 24px);
        height: 36px;
        display: flex;
        align-items: center;
        .title {
          flex: 1;
          font-size: 16px;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .mainWrapper {
      width: calc(100% - 410px);
      :deep(.el-radio) {
        width: 100px;
        line-height: 24px;
      }
    }

    .cardWrapper {
      .header {
        display: flex;
        align-items: center;
        .title {
          flex: 1;
        }
      }
    }
  }
}
.treeWrapper {
  max-height: 50vh;
  overflow-y: auto;
  :deep(.el-tree-node__content) {
    height: auto;
  }
}
.wang-editor-style {
  padding: 0px;
  :deep(.wang-editor-toolbar) {
    margin-top: -10px;
  }
  :deep(.wang-editor-body) {
    height: 300px;
  }
}
</style>
